export const THEME_PRESETS = {
  spring: {
    id: "spring",
    label: "Spring",
    assets: {
      headerAvatar: "/assets/images/profile/avatar_transparent.png",
      aboutPhoto: "/assets/images/profile/profile-spring.png",
      switcherIcon: "/assets/images/profile/spring.png",
    },
    cssVars: {
      "--element-primary-color": "#292326",
      "--element-secondary-color": "#6d5f65",
      "--background-primary-color": "#ffffff",
      "--border-color": "#dfd2d8",
      "--highlight-color": "rgba(236, 138, 176, 0.24)",
      "--accent-olive": "#7b9868",
      "--accent-forest": "#4f6d43",
      "--accent-amber": "#e982ad",
      "--accent-amber-strong": "rgba(236, 125, 170, 0.74)",
      "--accent-amber-soft": "rgba(247, 187, 210, 0.44)",
      "--accent-border-strong": "rgba(224, 124, 164, 0.58)",
      "--accent-olive-soft": "rgba(123, 152, 104, 0.48)",
      "--map-sphere-stroke": "rgba(105, 122, 97, 0.13)",
      "--map-graticule-stroke": "rgba(123, 152, 104, 0.1)",
      "--map-country-fill": "#e3e6df",
      "--map-country-stroke": "rgba(255, 255, 255, 0.68)",
      "--map-route-start": "#9dad8f",
      "--map-route-stroke": "#b99aa6",
      "--map-route-end": "#d88fab",
      "--map-route-active": "#cf7fa1",
      "--map-route-glow": "#d88fab",
      "--map-route-trail-stroke": "rgba(255, 255, 255, 0.74)",
      "--map-marker-color": "#d88fab",
      "--map-marker-border": "#ffffff",
      "--map-marker-ring": "rgba(216, 143, 171, 0.42)",
      "--map-tooltip-bg": "rgba(255, 252, 253, 0.98)",
      "--map-tooltip-border": "rgba(123, 152, 104, 0.16)",
      "--map-tooltip-shadow": "rgba(75, 85, 66, 0.08)",
      "--avatar-floor-color": "#e982ad",
      "--avatar-floor-shadow": "rgba(198, 93, 136, 0.25)",
    },
  },
  autumn: {
    id: "autumn",
    label: "Autumn",
    assets: {
      headerAvatar: "/assets/images/profile/avatar_transparent.png",
      aboutPhoto: "/assets/images/profile/profile-autumn.png",
      switcherIcon: "/assets/images/profile/fall.png",
    },
    cssVars: {
      "--element-primary-color": "#2b2a23",
      "--element-secondary-color": "#636553",
      "--background-primary-color": "#ffffff",
      "--border-color": "#d8d2c6",
      "--highlight-color": "rgba(224, 138, 65, 0.3)",
      "--accent-olive": "#6f7b4b",
      "--accent-forest": "#55603b",
      "--accent-amber": "#e69147",
      "--accent-amber-strong": "rgba(249, 149, 62, 0.82)",
      "--accent-amber-soft": "rgba(238, 172, 113, 0.45)",
      "--accent-border-strong": "rgba(224, 138, 65, 0.68)",
      "--accent-olive-soft": "rgba(111, 123, 75, 0.6)",
      "--map-sphere-stroke": "rgba(113, 98, 73, 0.14)",
      "--map-graticule-stroke": "rgba(139, 118, 84, 0.1)",
      "--map-country-fill": "#ded9cb",
      "--map-country-stroke": "rgba(255, 255, 255, 0.62)",
      "--map-route-start": "#90906b",
      "--map-route-stroke": "#ad8c63",
      "--map-route-end": "#d18a4c",
      "--map-route-active": "#c97936",
      "--map-route-glow": "#d18a4c",
      "--map-route-trail-stroke": "rgba(255, 248, 237, 0.7)",
      "--map-marker-color": "#747a4e",
      "--map-marker-border": "#f8f5ee",
      "--map-marker-ring": "rgba(194, 121, 54, 0.42)",
      "--map-tooltip-bg": "rgba(250, 247, 240, 0.98)",
      "--map-tooltip-border": "rgba(139, 108, 68, 0.18)",
      "--map-tooltip-shadow": "rgba(78, 62, 42, 0.08)",
      "--avatar-floor-color": "#e69147",
      "--avatar-floor-shadow": "rgba(177, 103, 39, 0.34)",
    },
  },
  blue: {
    id: "blue",
    label: "Summer",
    assets: {
      headerAvatar: "/assets/images/profile/avatar_transparent.png",
      aboutPhoto: "/assets/images/profile/profile-blue.png",
      switcherIcon: "/assets/images/profile/summer.png",
    },
    cssVars: {
      "--element-primary-color": "#1d1f24",
      "--element-secondary-color": "#606572",
      "--background-primary-color": "#ffffff",
      "--border-color": "#c9ced8",
      "--highlight-color": "rgba(64, 111, 221, 0.2)",
      "--accent-olive": "#2f6dff",
      "--accent-forest": "#0f327f",
      "--accent-amber": "#2f6dff",
      "--accent-amber-strong": "rgba(64, 111, 221, 0.72)",
      "--accent-amber-soft": "rgba(120, 154, 235, 0.42)",
      "--accent-border-strong": "rgba(67, 112, 220, 0.6)",
      "--accent-olive-soft": "rgba(47, 109, 255, 0.6)",
      "--map-sphere-stroke": "rgba(47, 109, 255, 0.12)",
      "--map-graticule-stroke": "rgba(47, 109, 255, 0.11)",
      "--map-country-fill": "#d7dde6",
      "--map-country-stroke": "rgba(255, 255, 255, 0.6)",
      "--map-route-start": "#8fa0bb",
      "--map-route-stroke": "#7e94b3",
      "--map-route-end": "#4d7ee0",
      "--map-route-active": "#2f6dff",
      "--map-route-glow": "#2f6dff",
      "--map-route-trail-stroke": "rgba(255, 255, 255, 0.76)",
      "--map-marker-color": "#2f6dff",
      "--map-marker-border": "#ffffff",
      "--map-marker-ring": "rgba(47, 109, 255, 0.44)",
      "--map-tooltip-bg": "rgba(255, 255, 255, 0.98)",
      "--map-tooltip-border": "rgba(47, 109, 255, 0.13)",
      "--map-tooltip-shadow": "rgba(32, 35, 42, 0.08)",
      "--avatar-floor-color": "#2f6dff",
      "--avatar-floor-shadow": "rgba(31, 77, 175, 0.3)",
    },
  },
  winter: {
    id: "winter",
    label: "Winter",
    assets: {
      headerAvatar: "/assets/images/profile/avatar_transparent.png",
      aboutPhoto: "/assets/images/profile/profile-winter.png",
      switcherIcon: "/assets/images/profile/winter.png",
    },
    cssVars: {
      "--element-primary-color": "#20242a",
      "--element-secondary-color": "#606a76",
      "--background-primary-color": "#ffffff",
      "--border-color": "#cfd8df",
      "--highlight-color": "rgba(123, 173, 207, 0.22)",
      "--accent-olive": "#4f86a8",
      "--accent-forest": "#27536f",
      "--accent-amber": "#6faed2",
      "--accent-amber-strong": "rgba(109, 174, 212, 0.72)",
      "--accent-amber-soft": "rgba(181, 218, 238, 0.44)",
      "--accent-border-strong": "rgba(103, 160, 196, 0.58)",
      "--accent-olive-soft": "rgba(79, 134, 168, 0.5)",
      "--map-sphere-stroke": "rgba(79, 134, 168, 0.14)",
      "--map-graticule-stroke": "rgba(103, 160, 196, 0.12)",
      "--map-country-fill": "#dfe6ea",
      "--map-country-stroke": "rgba(255, 255, 255, 0.68)",
      "--map-route-start": "#b5c6d0",
      "--map-route-stroke": "#9bb4c3",
      "--map-route-end": "#6faed2",
      "--map-route-active": "#5f9fc6",
      "--map-route-glow": "#6faed2",
      "--map-route-trail-stroke": "rgba(255, 255, 255, 0.78)",
      "--map-marker-color": "#6faed2",
      "--map-marker-border": "#ffffff",
      "--map-marker-ring": "rgba(111, 174, 210, 0.42)",
      "--map-tooltip-bg": "rgba(252, 254, 255, 0.98)",
      "--map-tooltip-border": "rgba(103, 160, 196, 0.16)",
      "--map-tooltip-shadow": "rgba(34, 50, 64, 0.08)",
      "--avatar-floor-color": "#6faed2",
      "--avatar-floor-shadow": "rgba(54, 108, 143, 0.22)",
    },
  },
};

export const DEFAULT_THEME_KEY = "spring";
export const SEASON_THEME_ORDER = ["spring", "blue", "autumn", "winter"];

export function getSeasonThemeKeyForDate(date = new Date()) {
  const month = date.getMonth();

  if (month >= 2 && month <= 4) return "spring";
  if (month >= 5 && month <= 7) return "blue";
  if (month >= 8 && month <= 10) return "autumn";
  return "winter";
}

export function getThemePreset(key = DEFAULT_THEME_KEY) {
  return THEME_PRESETS[key] || THEME_PRESETS[DEFAULT_THEME_KEY];
}

export function applyThemePreset(key = DEFAULT_THEME_KEY) {
  const preset = getThemePreset(key);
  if (typeof document === "undefined") return preset;

  const root = document.documentElement;
  root.setAttribute("data-theme", preset.id);

  Object.entries(preset.cssVars).forEach(([name, value]) => {
    root.style.setProperty(name, value);
  });

  return preset;
}
